$(document).ready(function(){
  addedin_wishlist();

  function count_wishlist(my_data){
    console.log(my_data);
    if(my_data.length == 0){
     $('header .wishlist-wrapper').removeClass('active'); 
      $('.wishlist-section .nohave-any-item').removeClass('hidden');
    }else{
      $('header .wishlist-wrapper').addClass('active');
      $('.wishlist-section .nohave-any-item').addClass('hidden');
    }
  }

  var stored__ = localStorage.getItem('AddedToWishlist');
  var getlist = stored__ ? JSON.parse(stored__) : [];
  count_wishlist(getlist);
  
  function addtolist(productHandle,productvariant){
    // var storedl = localStorage.getItem('AddedToWishlist');
    // var getlist = storedl ? JSON.parse(storedl) : [];

    //    if($('.wishlistpage').length > 0){
    //       $('.nohave-any-item').hide();
    //    }
    // else
    //    {
    //      $('.nohave-any-item').show();
    //    }
  }

  function updateWishlistCount() {
    var storedl = localStorage.getItem('AddedToWishlist');
    var getlist = storedl ? JSON.parse(storedl) : [];
    var wishlistCount = getlist.length;

    // Update the count in the wishlist bubble
    $('.wishlist-count-bubble span').text(wishlistCount);
  }

  
  $('body').on('click','.wishlist-icon', function(e) {
    e.preventDefault();

    var loadingbar = document.querySelector(".loading-bar");
    var loadingbarinner = document.querySelector(".loading-bar-inner");
    loadingbar.classList.add("is-visible");
    loadingbarinner.style.transform="scaleX(0.4)";
    
    var not_added = false;
    var productHandle = $(this).attr('product-handle');
    var productvariant = $(this).attr('data-varint-id');
    var storedl = localStorage.getItem('AddedToWishlist');
    var getlist = storedl ? JSON.parse(storedl) : [];


    if($(this).hasClass('added-in-wishlist') && !$(this).hasClass('.thisis_product') || $('.wishlistpage').length > 0){
      var newlist = [];
      for(var i=0; i < getlist.length;i++){
        var whole_obj = getlist[i].split(':');
        if(whole_obj[0] != productHandle){
          newlist.push(getlist[i]);
        }
      }
        // $(this).removeClass('added-in-wishlist');
      count_wishlist(newlist);
      localStorage.setItem('AddedToWishlist', JSON.stringify(newlist));
      
      if($('.wishlistpage').length > 0){
        if(newlist.length == 0 || newlist =='[null]' && newlist == null){
          $('.nohave_any_item').removeClass('hidden');
           // $('.nohave-any-item').hide();
        }
        $(this).parents('.whishlist-grid-item').remove();
      }else{
         // $('.nohave-any-item').show();
        $(this).removeClass('added-in-wishlist');
      }
            
    }else{

        var all_handles = [];
        var all_vriants = [];
        var is_in = 0;
        for(var i=0; i < getlist.length;i++){
          var whole_p = getlist[i].split(':');
          var pih = whole_p[0];
          var variants = whole_p[1].split(',');
          if(variants.indexOf(productvariant) > -1){
            is_in = 1;
          }
          all_handles.push(pih);
          all_vriants.push(whole_p[1]);
        }
    
        if(all_handles.indexOf(productHandle) == -1 && is_in == 0){
          //add
          var new_p_handle = productHandle + ':' + productvariant;
          getlist.push(new_p_handle);
          count_wishlist(getlist);
          localStorage.setItem('AddedToWishlist', JSON.stringify(getlist));
          $(this).addClass('added-in-wishlist');
          $('.wishlist-succes-popup').addClass('open');
          setTimeout(function(){
            $('.wishlist-succes-popup').removeClass('open');
          },5000);
          
        }else if(all_handles.indexOf(productHandle) > -1 && is_in == 0){
          var sq = all_handles.indexOf(productHandle);
          var current_vrs = all_vriants[sq] + ',' +  productvariant;
          var new_p_handle = productHandle + ':' + current_vrs;
          getlist[sq] = new_p_handle;
          count_wishlist(getlist);
          localStorage.setItem('AddedToWishlist', JSON.stringify(getlist));
          $(this).addClass('added-in-wishlist');
          $('.wishlist-succes-popup').addClass('open');
          setTimeout(function(){
            $('.wishlist-succes-popup').removeClass('open');
          },5000);
          
        }else{
          //remove
          $(this).removeClass('added-in-wishlist');
          var newlist = [];
          for(var i=0; i < getlist.length;i++){
            var whole_obj = getlist[i].split(':');
            var only_h = whole_obj[0];
            if(only_h == productHandle){
              var only_vs = whole_obj[1].split(',');
              var countvar = [];
              for(var j = 0;j<only_vs.length;j++){
                if(only_vs[j] != productvariant){
                  countvar.push(only_vs[j]); 
                }
              }
              if(countvar.length > 0){
                var cl = productHandle + ':' + countvar;
                newlist.push(cl);
              }
              console.log(countvar);
            }else{
              newlist.push(getlist[i]);
            }
          }
          // if(newlist.length == 0){
          //   $('.nohave-any-item').hide();
          // }
          count_wishlist(newlist);
          localStorage.setItem('AddedToWishlist', JSON.stringify(newlist));
        }
    }
    loadingbarinner.style.transform="scaleX(1)";
    setTimeout(function(){
      loadingbar.classList.remove("is-visible");
      loadingbarinner.style.transform="scaleX(0)";  
    },1000);
    
  });

  function wishlistpage() {
    
    if($('.wishlistpage').length > 0){

      var storedl = localStorage.getItem('AddedToWishlist');
      
      var getlist = storedl ? JSON.parse(storedl) : [];
      
      if(getlist.length > 0 && storedl !='[null]' && storedl != null){

      $('.nohave_any_item').addClass('hidden');

      $('#product-grid.whishlist-grid').empty();
          
       // $('.nohave-any-item').hide(); // Hides the empty wishlist message
     
        for(var i=0; i < getlist.length;i++){
          
          var phandle = getlist[i].split(':');
          $.get('/products/' + phandle[0] + '?view=wishlist-ajax',function(response) {
            // console.log(response);
            
            $('#product-grid.whishlist-grid').append(response);
            
            $('#product-grid.whishlist-grid .wishlist-icon').addClass('added-in-wishlist');
            
            if($('.wishlistpagebody quick-add-modal').length > 0){
              
              $('.wishlistpagebody').remove('quick-add-modal');
            }
          });
        } 
       }else{

        // $('.nohave-any-item').show()
        $('.nohave_any_item').removeClass('hidden');
      }
    }
  }
  wishlistpage();
});

// $(document).ready(function() {

//     loadWishlist();
  
//      $(document).on('click', '.add-to-wishlist', function() {
       
//       var productHandle = $(this).attr('product-handle');
       
//       addToWishlist(productHandle);
       
//     });
  
//       $(document).on('click', '.wishlist-remove', function() {
        
//           // Get the product handle from the clicked element's data attribute
//           var productHandle = $(this).attr('product-handle');
          
//           console.log('Removing product handle:', productHandle); // Check the value in the console
          
//           // Call the function to remove the item from localStorage and UI
//           removeFromWishlist(productHandle);
          
//           // Remove the item from the wishlist UI
//           $(this).closest('.grid__item').remove();

//             removeFromWishlist(productHandle);

//             $.ajax({
//               url: '/wishlist/remove', // Server endpoint for removal
//               type: 'POST',
//               data: JSON.stringify({ productId: productId }),
//               contentType: 'application/json',
//               success: function(response) {
//                   console.log('Item removed from wishlist on server:', response);
//                   // Optionally, update the UI or give feedback to the user
//               },
//               error: function(xhr, status, error) {
//                   console.error('Error removing item from wishlist on server:', error);
//               }
//           });
//       });
    
  
//      $(document).on("click", '.wsl-body .card-wrapper .wishlist-icon', function() {
       
//       // Adds 'wishlist-remove' class to all '.wishlist-icon' elements inside '.wsl-body'
       
//       $(this).parents('.wsl-body').find('.card-wrapper').find('.wishlist-icon').addClass('wishlist-remove');
  
//       // Removes 'wishlist-fill-icon' class from all '.wishlist-icon' elements inside '.wsl-body'
       
//       $(this).parents('.wsl-body').find('.card-wrapper').find('.wishlist-icon').removeClass('wishlist-fill-icon');
       
//     });
  
    
//     $(document).on("click", '.wishlist-icon', function() {
      
//         var productHandle = $(this).attr('product-handle');
  
//         var productid = $(this).attr('product-id');
  
//         var isAdded = $(this).hasClass('wishlist-fill-icon'); // Check if already in wishlist
  
//         var wishlistData = localStorage.getItem('wishlistData');
  
//         $(this).parents('.wsl-body').find('.card-wrapper').find('.wishlist-icon').addClass('wishlist-remove');
        
//         var wishlist = wishlistData ? JSON.parse(wishlistData) : [];
  
//         var count = wishlist.length;
  
//         console.log(wishlist);
       
//         updateWishlistCount();
  
//          if (!$(this).closest('.wsl-body').length) {
           
//           // If not within '.wsl-body', toggle the class 'wishlist-fill-icon'
           
//             $(this).toggleClass('wishlist-fill-icon');
//           }
      
//           // You can place additional logic here, such as calling functions
//           // For example, handle adding or removing from wishlist
      
//           if (isAdded) {
//               removeFromWishlist(productHandle);
//           } else {
//               addToWishlist(productHandle);
//           }
          
//        })
  
//        function addToWishlist(productHandle) {
  
//         var wishlistData = localStorage.getItem('wishlistData');
//         var wishlist = wishlistData ? JSON.parse(wishlistData) : [];
  
//         var count = wishlist.length;
  
//         console.log(wishlist);
  
//         if (wishlist.length === 0) {
//           $('.wishlist-text').removeClass('hidden');
//           $('.wishlist-count-bubble').addClass('hidden');
//         } 
//         else
//         {
//           $('.wishlist-text').addClass('hidden');
//           $('.wishlist-count-bubble').removeClass('hidden'); // Show the count bubble
//           $('.wishlist-count').text(count);
//         }
      
//         // Check if the product is already in the wishlist
  
//         if (!wishlist.includes(productHandle)) {
          
//         wishlist.push(productHandle);
          
//         localStorage.setItem('wishlistData', JSON.stringify(wishlist));
          
//         fetchProductDetails(productHandle);
          
//         updateWishlistCount();
//       }
  
//     }
  
//     function removeFromWishlist(productHandle) {
        
//       var wishlistData = localStorage.getItem('wishlistData');
//       var wishlist = wishlistData ? JSON.parse(wishlistData) : [];
  
//       var index = wishlist.indexOf(productHandle);
        
//       if (index !== -1) {
        
//         wishlist.splice(index, 1);
        
//         localStorage.setItem('wishlistData', JSON.stringify(wishlist));
  
//           $('.wsl-body .wsl-products .grid__item[data-product-handle="' + productHandle + '"]').remove();
  
//           updateWishlistCount();
//       }
//     }
  
  
//     function fetchProductDetails(productHandle) {
//         $.ajax({
//         type: 'GET',
//         url: '/products/' + productHandle + '.js',
//         dataType: 'json',
//         success: function(response) {
  
//           var baseURL = '/products/' + productHandle;
//           var productImage = response.featured_image;
//           var productName = response.title;
//           var productPrice = (response.price / 100).toFixed(2);
  
//           var productid = $(this).attr('product-id');

//           console.log(productName);
  
//           var productCardHtml =
            
//           '<div class="grid__item whishlist-grid-item col-3">'+
//             '<div class="whishlist-grid-item-wrapper " id="product-card-wrapper" product-id="'+ productid +'" data-product-handle="'+ productHandle +'">'+
//             '<div class=" card card--standard card--media" style="--ratio-percent: 100.0%;">'+
//             '<div class="card__inner color-scheme-2 gradient ratio" style="--ratio-percent: 100.0%;">'+
//             '<div class="quick-view-wrapper">'+
//             '<div class="tooltip">Quick View</div>'+
//               '<div class="quick-view" data-handle=" '+ productHandle +' " data-id="'+ productid +'">'+
//                 '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M20.2173 10.1598C21.2609 11.2056 21.2609 12.7944 20.2173 13.8402C18.4571 15.604 15.434 18 12 18C8.56604 18 5.54294 15.604 3.78274 13.8402C2.73909 12.7944 2.73909 11.2056 3.78273 10.1598C5.54294 8.396 8.56604 6 12 6C15.434 6 18.4571 8.396 20.2173 10.1598Z" stroke="#2E3192" stroke-width="1.5"></path><circle cx="12" cy="12" r="3" stroke="#2E3192" stroke-width="1.5"></circle> </svg>'+
//               '</div>'+
//             '</div>'+
//             '<div class="wishlist-view-wrapper">'+
//               '<div class="wishlist-icon  wishlist-remove " product-handle="'+ productHandle +'">'+
//               '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0" y="0" viewBox="0 0 512.001 512" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M256 455.516c-7.29 0-14.316-2.641-19.793-7.438-20.684-18.086-40.625-35.082-58.219-50.074l-.09-.078c-51.582-43.957-96.125-81.918-127.117-119.313C16.137 236.81 0 197.172 0 153.871c0-42.07 14.426-80.883 40.617-109.293C67.121 15.832 103.488 0 143.031 0c29.555 0 56.621 9.344 80.446 27.77C235.5 37.07 246.398 48.453 256 61.73c9.605-13.277 20.5-24.66 32.527-33.96C312.352 9.344 339.418 0 368.973 0c39.539 0 75.91 15.832 102.414 44.578C497.578 72.988 512 111.801 512 153.871c0 43.3-16.133 82.938-50.777 124.738-30.993 37.399-75.532 75.356-127.106 119.309-17.625 15.016-37.597 32.039-58.328 50.168a30.046 30.046 0 0 1-19.789 7.43zM143.031 29.992c-31.066 0-59.605 12.399-80.367 34.914-21.07 22.856-32.676 54.45-32.676 88.965 0 36.418 13.535 68.988 43.883 105.606 29.332 35.394 72.961 72.574 123.477 115.625l.093.078c17.66 15.05 37.68 32.113 58.516 50.332 20.961-18.254 41.012-35.344 58.707-50.418 50.512-43.051 94.137-80.223 123.469-115.617 30.344-36.618 43.879-69.188 43.879-105.606 0-34.516-11.606-66.11-32.676-88.965-20.758-22.515-49.3-34.914-80.363-34.914-22.758 0-43.653 7.235-62.102 21.5-16.441 12.719-27.894 28.797-34.61 40.047-3.452 5.785-9.53 9.238-16.261 9.238s-12.809-3.453-16.262-9.238c-6.71-11.25-18.164-27.328-34.61-40.047-18.448-14.265-39.343-21.5-62.097-21.5zm0 0" fill="#2E3192" opacity="1" data-original="#000000" class=""></path></g> </svg>'+
//               '</div>'+
//               '</div>'+
//               '<div class="card__media">'+
//                 '<div class="media media--transparent media--hover-effect product-card-image">'+
//                   '<img src="'+ productImage +'" alt=" '+ productName + '" class="motion-reduce" width="360" height="360">'+
//                   '</div>'+
//                   '</div>'+
//                   '<div class="card__content">'+
//                   '<div class="card__information">'+
//                   '<a href=" '+ baseURL  +'">'+
//                    '<h3 class="card__heading" data-product-name="'+ productName +'">' + productName +'</h3>'+
//                   '</a>'+
//                   '</div>'+
//                   '<div class="card__badge bottom left"></div>'+
//                   '</div>'+
//                 '</div>'+
              
//                 '<div class="card__content">'+
//                   '<div class="card__information">'+
//                   '<a href=" '+ baseURL  +'">'+
//                     '<h3 class="card__heading h5" data-product-name="" id="title-template--22903629087034__product-grid-8968344437050">'+ productName +'</h3>'+
//                    '</a>'+
//                     '<div class="card-information"><span class="caption-large light"></span>'+
//                       '<div class=" price">'+
//                         '<div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>'+
//                             '<span class="price-item price-item--regular" > ' +  productPrice + ' </span>'+
//                         '</div>'+
//                       '</div>'+
                  
//                         '<product-form class="product-form" data-section-id="template--22903629087034__product-grid">'+
//                           '<form method="post" action="/cart" class="form" id="add-to-cart-dewy-rosewater-facial-spray" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">'+
//                             '<input type="hidden" name="id" value="" class="variantid_to_add product-variant-id">'+
//                             '<div class="button-add-to-cart">'+
//                               '<button type="submit" name="add" href="javascript:void(0)" class="button-add-to-cart" value="true" data-product-key="47674388283706">'+
//                                 '<svg class="cart-icon" width="22" height="22" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.5 1.25C1.08579 1.25 0.75 1.58579 0.75 2C0.75 2.41421 1.08579 2.75 1.5 2.75V1.25ZM4.5 5.75C4.08579 5.75 3.75 6.08579 3.75 6.5C3.75 6.91421 4.08579 7.25 4.5 7.25V5.75ZM16.125 7.25C16.5392 7.25 16.875 6.91421 16.875 6.5C16.875 6.08579 16.5392 5.75 16.125 5.75V7.25ZM7.5 15.875C7.5 16.0821 7.33211 16.25 7.125 16.25V17.75C8.16053 17.75 9 16.9105 9 15.875H7.5ZM7.125 16.25C6.91789 16.25 6.75 16.0821 6.75 15.875H5.25C5.25 16.9105 6.08947 17.75 7.125 17.75V16.25ZM6.75 15.875C6.75 15.6679 6.91789 15.5 7.125 15.5V14C6.08947 14 5.25 14.8395 5.25 15.875H6.75ZM7.125 15.5C7.33211 15.5 7.5 15.6679 7.5 15.875H9C9 14.8395 8.16053 14 7.125 14V15.5ZM14.25 15.875C14.25 16.0821 14.0821 16.25 13.875 16.25V17.75C14.9105 17.75 15.75 16.9105 15.75 15.875H14.25ZM13.875 16.25C13.6679 16.25 13.5 16.0821 13.5 15.875H12C12 16.9105 12.8395 17.75 13.875 17.75V16.25ZM13.5 15.875C13.5 15.6679 13.6679 15.5 13.875 15.5V14C12.8395 14 12 14.8395 12 15.875H13.5ZM13.875 15.5C14.0821 15.5 14.25 15.6679 14.25 15.875H15.75C15.75 14.8395 14.9105 14 13.875 14V15.5ZM4.5 4.25H13.5V2.75H4.5V4.25ZM15.75 6.5V10.25H17.25V6.5H15.75ZM13.5 12.5H7.5V14H13.5V12.5ZM5.25 10.25V3.5H3.75V10.25H5.25ZM3 1.25H1.5V2.75H3V1.25ZM4.5 7.25H16.125V5.75H4.5V7.25ZM5.25 3.5C5.25 2.25736 4.24264 1.25 3 1.25V2.75C3.41421 2.75 3.75 3.08579 3.75 3.5H5.25ZM7.5 12.5C6.25736 12.5 5.25 11.4926 5.25 10.25H3.75C3.75 12.3211 5.42893 14 7.5 14V12.5ZM15.75 10.25C15.75 11.4926 14.7426 12.5 13.5 12.5V14C15.5711 14 17.25 12.3211 17.25 10.25H15.75ZM13.5 4.25C14.7426 4.25 15.75 5.25736 15.75 6.5H17.25C17.25 4.42893 15.5711 2.75 13.5 2.75V4.25Z" fill="#FCFDFF"></path></svg>'+
//                                '<span class="text">  ADD TO CART </span>'+
//                               '</button>'+
//                             '</div>'+
//                           '</form>'+
//                         '</product-form>'+
//                       '</div>'+
//                    '</div>'+
//                  '</div>'+
//                '</div>'+
//               '</div>'+
//             '</div>'+
//             '</div>';
    
//            $('.wsl-ul').append(productCardHtml);
  
//            $('.wishlistItem').find('.wishlist-remove').on('click', function() {
//               var productHandle = $(this).data('product-handle');
//               removeFromWishlist(productHandle);
//           });
    
//           },
//           error: function(xhr, status, error) {
//             console.error('Error fetching product data:', error);
//            }
//         });
//     }
  
  
//     function updateWishlistCount() {
  
//       var wishlistData = localStorage.getItem('wishlistData');
//       var wishlist = wishlistData ? JSON.parse(wishlistData) : [];
//       var count = wishlist.length;
  
  
//       if (count === 0) {
//         $('.wishlist-text').removeClass('hidden');
//         $('.wishlist-count-bubble').addClass('hidden');
//       } else {
//         $('.wishlist-text').addClass('hidden');
//         $('.wishlist-count-bubble').removeClass('hidden');
//         $('.wishlist-count').text(wishlist.length);
//       }
//     }
  
//     function loadWishlist() {
      
//       var wishlistData = localStorage.getItem('wishlistData');
//       var wishlist = wishlistData ? JSON.parse(wishlistData) : [];
  
//        if (wishlist.length === 0) {
         
//         // Display a message if the wishlist is empty
         
//         $('.wsl-ul').html('<p>Your wishlist is currently empty.</p>');
//         $('.wishlist-count').text(0);
//         return;
//       }
  
//       wishlist.forEach(function(productHandle) {
//         $('.wishlist-icon[product-handle="' + productHandle + '"]').addClass('wishlist-fill-icon');
//         fetchProductDetails(productHandle);
//       });
      
//     }
//       updateWishlistCount();
//   });
      

// $(document).ready(function() {

//   // Retrieve wishlist from localStorage or initialize empty array
  
//   var wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

//   // Handle wishlist icon click
//   $(document).on('click', '.wishlist-icon', function() {
    
//     var productHandle = $(this).attr('product-handle');
//     var $icon = $(this);
//     var isAdded = $icon.hasClass('wishlist-fill-icon'); // Check if product is in wishlist

//     // Fetch product details via AJAX
//     $.ajax({
//       type: 'GET',
//       url: '/products/' + productHandle + '.js',
//       dataType: 'json',
//       success: function(response) {
        
//         var product = {
//           handle: productHandle,
//           image: response.featured_image,
//           name: response.title,
//           price: (response.price / 100).toFixed(2)
//         };

//         if (isAdded) {
//           // Remove product from wishlist
//           wishlist = wishlist.filter(item => item.handle !== productHandle);
//           $icon.removeClass('wishlist-fill-icon'); // Toggle icon state
//         } else {
//           // Add product to wishlist
//           wishlist.push(product);
//           $icon.addClass('wishlist-fill-icon'); // Toggle icon state
//         }

//         // Update wishlist in localStorage
//         localStorage.setItem('wishlist', JSON.stringify(wishlist));

//         // Update wishlist UI (optional)
//         updateWishlistUI(product);
//       },
//       error: function() {
//         console.log('Error fetching product details.');
//       }
//     });
//   });

//   // Update the wishlist UI (example function)
//   function updateWishlistUI(product) {
//     var productCardHtml = 
//       '<div class="wishlist-grid-item col-3">'+
//         '<div class="wishlist-grid-item-wrapper">'
//           '<a href="/products/${product.handle}" class="wishlist-product-link">'+
//             '<div class="wishlist-product-media">'+
//               '<div class="wishlist-product-image-wrapper">'+
//                 '<img class="wishlist-product-image" src="${product.image}" alt="${product.name}">'+
//               '</div>'+
//             '</div>'+
//             '<div class="wishlist-product-content">'+
//               '<h3 class="wishlist-product-title">${product.name}</h3>'+
//               '<div class="wishlist-product-price-wrapper">'+
//                 '<span class="wishlist-product-price">£${product.price}</span>'+
//               '</div>'+
//             '</div>'+
//           '</a>'+
//         '</div>'+
//       '</div>';

//     // Append or remove product in the wishlist UI
//     if ($('.wishlist-fill-icon').hasClass('wishlist-fill-icon')) {
//       $('.wishlist-items-container').append(productCardHtml);
//     } else {
//       $('.wishlist-grid-item-wrapper[product-handle="${product.handle}"]').remove();
//     }
//   }

// });
